import { sendPasswordResetEmail } from 'firebase/auth';
import { Mail } from 'lucide-react';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { auth } from '../utils/firebase';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export default function ForgetPassword() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      toast.success(t('auth.forgetPassword.success', { email }));
    } catch (error) {
      console.error(error);
      toast.error(t('auth.forgetPassword.error'));
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className='w-full min-h-[calc(100vh-6.5rem)] flex-center'>
      <div className="flex-center gap-4 min-w-72 p-4">
        <p>{t('auth.forgetPassword.title')}</p>
        <label className="input input-bordered flex items-center gap-2 w-full">
          <Mail />
          <input type="text" className="grow" placeholder={t('auth.email')} value={email} onChange={(e) => { setEmail(e.target.value) }} />
        </label>
        <button onClick={handleSubmit} className="w-full btn btn-primary" disabled={isLoading}>
          {isLoading ? <span className="loading loading-spinner" /> : t('auth.forgetPassword.submit')}
        </button>
        <button className="btn btn-ghost underline w-full opacity-80" onClick={() => navigate("/login")}>
          {t('auth.forgetPassword.login')}
        </button>
      </div>
    </div>
  )
}
